import type { ComparisonValue } from './types';

/**
 * Comparison rows shared by the industry verticals (same order as
 * `comparison.rows[]`): online booking, reminders, self-service changes,
 * team calendar, questions before the visit, client history.
 * Columns: the two old ways each vertical names, then Sloty.
 */
export const VERTICAL_COMPARISON: ComparisonValue[][] = [
  ['n', 'n', 'y'],
  ['n', 'n', 'y'],
  ['n', 'n', 'y'],
  ['p', 'n', 'y'],
  ['n', 'n', 'y'],
  ['p', 'n', 'y'],
];
